import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const LibraryCustom = Scrivito.provideObjClass("LibraryCustom", {
  attributes: {
    body: ["widgetlist", { only: "SectionWidget" }],
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
  extractTextAttributes: ["body", "title", "subtitle"],
});

export default LibraryCustom;
